var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "btn-disabled-gray" }, [
    _c(
      "div",
      { staticClass: "btn-toolbar mb-2", attrs: { "data-toggle": "buttons" } },
      _vm._l(_vm.labels, function(item, index) {
        return _c(
          "button",
          {
            staticClass: "btn",
            class: {
              "btn-primary active": _vm.selectedIndex == index,
              "btn-link": _vm.selectedIndex != index
            },
            on: {
              click: function($event) {
                return _vm.selectLabel(index)
              }
            }
          },
          [_vm._v("\n      " + _vm._s(item.name) + "\n    ")]
        )
      }),
      0
    ),
    _vm._v(" "),
    _vm.selectedIndex == 0 ? _c("div", [_c("CellUi")], 1) : _vm._e(),
    _vm._v(" "),
    _vm.selectedIndex == 1 ? _c("div", [_c("LineUi")], 1) : _vm._e(),
    _vm._v(" "),
    _vm.selectedIndex == 2 ? _c("div", [_c("AreaUi")], 1) : _vm._e(),
    _vm._v(" "),
    _vm.selectedIndex == 3 ? _c("div", [_c("Config")], 1) : _vm._e(),
    _vm._v(" "),
    _vm.selectedIndex == 4 ? _c("div", [_c("LinksUi")], 1) : _vm._e(),
    _vm._v(" "),
    _vm.selectedIndex == 5 ? _c("div", [_c("Oee")], 1) : _vm._e(),
    _vm._v(" "),
    _vm.selectedIndex == 6 ? _c("div", [_c("Shift")], 1) : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }